import { defineStore, acceptHMRUpdate } from "pinia"
import type { Create } from "@/pocketbase-types"

export const useAuthStore = defineStore("auth", {
  state: () => ({
    loggedIn: false,
    email: "",
    owner: false
  }),
  getters: {},
  actions: {
    setState() {
      this.loggedIn = this.pb.authStore.isValid
      this.email = this.pb.authStore.record?.email ?? ""
      this.owner = this.pb.authStore.record?.expand?.household.name === "Arnfield"
    },
    async loginPassword(email: string | null, password: string | null) {
      if (email && password) {
        await this.pb.collection("users").authWithPassword(email, password, { expand: "household" })
        this.setState()
      }
    },
    async oidcData() {
      const providers = await this.pb.collection("users").listAuthMethods()
      return providers["oauth2"].providers.find(p => p.name == "oidc")
    },
    async loginPasskey(w: Window) {
      await this.pb.collection("users").authWithOAuth2({
        provider: "oidc",
        urlCallback: url => {
          w.location.href = url
        }
      })
      this.setState()
    },
    async refresh() {
      await this.pb
        .collection("users")
        .authRefresh({ expand: "household" })
        .catch(() => {
          this.pb.authStore.clear()
        })
      this.setState()
    },
    logOut() {
      this.pb.authStore.clear()
      this.setState()
    },
    getInvite(code: string) {
      return this.pb.collection("invites").getFirstListItem(`code="${code}"`)
    },
    async createUser(code: string, userProps: Omit<Create<"users">, "tokenKey" | "household">) {
      await this.pb.send("/api/createAccount", { method: "POST", body: { code, ...userProps } })
      await this.loginPassword(userProps.email, userProps.password)
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot))
}
